import { render, staticRenderFns } from "./FormCustomerPartnerImport.vue?vue&type=template&id=63d94870&scoped=true"
import script from "./FormCustomerPartnerImport.vue?vue&type=script&lang=js"
export * from "./FormCustomerPartnerImport.vue?vue&type=script&lang=js"
import style0 from "./FormCustomerPartnerImport.vue?vue&type=style&index=0&id=63d94870&prod&lang=scss&scoped=true"
import style1 from "./FormCustomerPartnerImport.vue?vue&type=style&index=1&id=63d94870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d94870",
  null
  
)

export default component.exports